<template lang="pug">
    v-text-field(v-model="formattedValue" :readonly="readonly" class="right-component" dense :required = "required"
        @focus="doDeformat" @blur="doFormat" :label="label" :rules="rules" prefix="Rp. " v-numeric-only)
        template(v-slot:prepend v-if="template")
            v-icon(color="yellow accent-4") mdi-cash-multiple
</template>
<script>
import DecimalFormat from "../../service/decimal-format";
export default {
  name: "FDecimalbox",
  props: {
    value: String | Number,
    label: String,
    rules: Array,
    required: Boolean,
    readonly: Boolean,
    template: Boolean,
    format: {
      type: String,
      default() {
        return "#,###.##";
      }
    }
  },
  data() {
    return {
      formatter: new DecimalFormat("#,###.##"),
      changeable: false,
      formatted: true
    };
  },
  mounted() {},
  methods: {
    doDeformat() {
      if (this.formattedValue) {
        this.formattedValue = this.formatter.formatBack(this.formattedValue);
        this.formatted = false;
      }
    },
    doFormat() {
      if (this.formattedValue) {
        this.formatted = true;
        this.formattedValue = this.formatter.format(this.formattedValue);
      }
    },
  },
  computed: {
    formattedValue: {
      get() {
        return this.formatted ? this.formatter.format(this.value) : this.value;
      },
      set(newValue) {
        if (this.formatted) {
          this.$emit("input", this.formatter.formatBack(newValue));
        } else {
          this.$emit("input", newValue);
        }
      }
    }
  }
};
</script>